import {
  Button, Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, Grid,
  Slide, TextField, Typography as Text
} from '@mui/material';
import React from 'react';

function Transition(props) {
  return <Slide direction="up" {...props} />;
}
let _ref = null;

export default class DialogAlert extends React.Component {
  constructor(props) {
    super(props);
    _ref = this;
    this.state = {
      heranca: {},
      open: false,
      prop: {},
      Component: Grid,
      action: [],
      input: null,
      texto: '',
    };
  }
  openDialog = ({ Component = Grid, prop = {}, propsDialog = {},
    title = '', description = '', texto = '', action = [], input = null }) => {
    this.setState({
      Component, prop, propsDialog,
      open: true, title, description, action, input, texto
    })
  }
  closeDialog = () => {
    this.setState({ open: !this.state.open })
  }
  render() {
    const { Component, prop, propsDialog, title, description, action, input } = this.state;

    return (

      <Dialog
        open={this.state.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={this.closeDialog}
        style={{ zIndex: 1400 }}
        {...propsDialog}
      >
        <DialogTitle id="alert-dialog-slide-title">  {title}</DialogTitle>
        <DialogContent>
          <Text>{description}</Text>
          <Component {...prop} onClose={this.closeDialog} />
          {input && <TextField autoFocusmargin="dense" fullWidth {...input} value={this.state.texto}
            onChange={event => {
              if (input.onChange) input.onChange(event.target.value)
              this.setState({ texto: event.target.value });
            }}
          />}
        </DialogContent>
        <DialogActions>
          {action[0] && action.map((data, key) => {
            return (
              <Button key={"key_" + key} onClick={() => {
                if (data.onClick) data.onClick()
                if (!data.notClose) this.closeDialog()
              }} color="primary">
                {data.label}
              </Button>
            )
          }) || <Button onClick={this.closeDialog} color="primary">OK </Button>
          }

        </DialogActions>
      </Dialog>

    );
  }
}

export function openDialog(...args) {
  if (_ref) {
    _ref.openDialog(...args);
  }
}
export function closeDialog(...args) {
  if (_ref) {
    _ref.closeDialog(...args);
  }
}
